/** Event Organizer namespace — keep en / zh / it in sync */
export const eoEn = {
  'eo.common.filter': 'Filter',
  'eo.common.saving': 'Saving…',
  'eo.workspace.title': 'Event Organizer',
  'eo.workspace.subtitle': 'Select or create an event',
  'eo.nav.overview': 'Overview',
  'eo.nav.events': 'Events',
  'eo.nav.newEvent': 'New event',
  'eo.nav.agenda': 'Agenda',
  'eo.nav.participants': 'Participants',
  'eo.nav.import': 'Import',
  'eo.nav.poster': 'Poster',
  'eo.nav.partners': 'Partners',
  'eo.nav.partnerDetail': 'Partner detail',
  'eo.nav.checklist': 'Checklist',
  'eo.nav.currentEvent': 'Current event',
  'eo.nav.switch': 'Switch event',
  'eo.nav.modules': 'Modules',
  'eo.nav.account': 'Account',
  'eo.nav.dashboard': 'Dashboard',
  'eo.events.subtitle': 'Create and manage your events',
  'eo.events.new': 'New event',
  'eo.events.newHint': 'Start from scratch',
  'eo.events.cap': 'Cap',
  'eo.event.status.live': 'Live',
  'eo.event.status.draft': 'Draft',
  'eo.event.status.archived': 'Archived',
  'eo.form.newSub': 'Basic details for your event',
  'eo.form.name': 'Event name',
  'eo.form.nameRequired': 'Event name is required',
  'eo.form.venue': 'Venue',
  'eo.form.venueRequired': 'Venue is required',
  'eo.form.description': 'Description',
  'eo.form.start': 'Start date',
  'eo.form.startRequired': 'Start date is required',
  'eo.form.end': 'End date',
  'eo.form.endRequired': 'End date is required',
  'eo.form.endBeforeStart': 'End must be on or after start',
  'eo.form.totalDays': 'Duration',
  'eo.form.day': 'day',
  'eo.form.days': 'days',
  'eo.form.cap': 'Max participants',
  'eo.form.cover': 'Cover image',
  'eo.form.coverHint': 'JPG or PNG, recommended 16:9',
  'eo.form.chooseFile': 'Choose file',
  'eo.form.saveContinue': 'Save & continue',
  'eo.agenda.share': 'Share',
  'eo.agenda.export': 'Export',
  'eo.agenda.addActivity': 'Add activity',
  'eo.agenda.conflictsDetected': 'Schedule conflicts detected',
  'eo.agenda.conflictsHint': 'Overlapping activities at the same venue',
  'eo.agenda.list': 'List',
  'eo.agenda.timeline': 'Timeline',
  'eo.agenda.exportStarted': 'Export started',
  'eo.agenda.linkGenerated': 'Public link created',
  'eo.agenda.linkFailed': 'Could not update public link',
  'eo.agenda.linkDisabled': 'Public link disabled',
  'eo.agenda.editActivity': 'Edit activity',
  'eo.agenda.ignoreSave': 'Save anyway',
  'eo.agenda.resolveConflict': 'Resolve conflict',
  'eo.agenda.activityTitle': 'Title',
  'eo.agenda.date': 'Date',
  'eo.agenda.start': 'Start',
  'eo.agenda.end': 'End',
  'eo.agenda.venue': 'Venue / room',
  'eo.agenda.type': 'Type',
  'eo.agenda.conflictTitle': 'Conflicts with another activity',
  'eo.agenda.exportTitle': 'Export agenda',
  'eo.agenda.generating': 'Generating…',
  'eo.agenda.startExport': 'Start export',
  'eo.agenda.format': 'Format',
  'eo.agenda.shareTitle': 'Share public agenda',
  'eo.agenda.previewPublic': 'Preview public page',
  'eo.agenda.copied': 'Copied',
  'eo.agenda.copyLink': 'Copy link',
  'eo.agenda.shareHint': 'Anyone with the link can view a read-only agenda.',
  'eo.agenda.generateLink': 'Generate link',
  'eo.agenda.linkStatus': 'Public link',
  'eo.agenda.disableLink': 'Disable link',
  'eo.agenda.enableLink': 'Enable link',
  'eo.public.expiredTitle': 'Link expired',
  'eo.public.expiredBody': 'This public agenda link is no longer valid.',
  'eo.public.eyebrow': 'Public agenda',
  'eo.public.footer': 'Powered by N-Excelsior',
  'eo.participants.total': 'total',
  'eo.participants.confirmed': 'confirmed',
  'eo.participants.attendance': 'attendance',
  'eo.participants.import': 'Import',
  'eo.participants.add': 'Add participant',
  'eo.participants.statTotal': 'Total',
  'eo.participants.statConfirmed': 'Confirmed',
  'eo.participants.statPending': 'Pending',
  'eo.participants.statAttendance': 'Attendance rate',
  'eo.participants.search': 'Search name or email',
  'eo.participants.allStatuses': 'All statuses',
  'eo.participants.colName': 'Name',
  'eo.participants.colCompany': 'Company',
  'eo.participants.colStatus': 'Status',
  'eo.participants.colCheckin': 'Check-in',
  'eo.participants.checkedIn': 'Checked in',
  'eo.participants.checkIn': 'Check in',
  'eo.participants.added': 'Participant added',
  'eo.participants.name': 'Name',
  'eo.participants.email': 'Email',
  'eo.participants.company': 'Company',
  'eo.import.title': 'Import participants',
  'eo.import.subtitle': 'Upload a CSV with name, email, company columns',
  'eo.import.drop': 'Drop CSV here or browse',
  'eo.import.total': 'Rows',
  'eo.import.valid': 'Valid',
  'eo.import.errors': 'Errors',
  'eo.import.back': 'Back',
  'eo.import.confirm': 'Import valid rows',
  'eo.import.done': 'Import complete',
  'eo.poster.title': 'Registration poster',
  'eo.poster.subtitle': 'Customize the landing poster for this event',
  'eo.poster.previewLanding': 'Preview landing',
  'eo.poster.saved': 'Poster saved',
  'eo.poster.save': 'Save poster',
  'eo.poster.templates': 'Templates',
  'eo.poster.customTitle': 'Headline',
  'eo.poster.deadline': 'Registration deadline',
  'eo.poster.scanToRegister': 'Scan to register',
  'eo.register.failed': 'Registration failed',
  'eo.register.successTitle': 'You are registered',
  'eo.register.successBody': 'A confirmation email will be sent shortly.',
  'eo.register.full': 'This event is full.',
  'eo.register.closed': 'Registration is closed.',
  'eo.register.signInFirst': 'Sign in to register',
  'eo.register.submit': 'Register',
  'eo.partners.subtitle': 'Sponsors and service partners',
  'eo.partners.add': 'Add partner',
  'eo.partners.allStatuses': 'All statuses',
  'eo.partners.negotiating': 'Negotiating',
  'eo.partners.confirmed': 'Confirmed',
  'eo.partners.completed': 'Completed',
  'eo.partners.terminated': 'Terminated',
  'eo.partners.added': 'Partner added',
  'eo.partners.company': 'Company',
  'eo.partners.level': 'Level',
  'eo.partners.tabInfo': 'Info',
  'eo.partners.tabContract': 'Contract',
  'eo.partners.tabLog': 'Communication',
  'eo.partners.contact': 'Contact',
  'eo.partners.contractDue': 'Contract due',
  'eo.partners.amount': 'Amount',
  'eo.partners.addLog': 'Add log entry',
  'eo.partners.logAdded': 'Log entry added',
  'eo.checklist.subtitle': 'Pre, during and post event tasks',
  'eo.checklist.useTemplate': 'Apply template',
  'eo.checklist.pre': 'Pre-event',
  'eo.checklist.during': 'During event',
  'eo.checklist.post': 'Post-event',
  'eo.checklist.newTask': 'New task title…',
  'eo.toast.eventCreated': 'Event created',
  'eo.toast.eventCreateFailed': 'Failed to create event',
  'eo.toast.eventSaved': 'Event saved',
  'eo.toast.eventSaveFailed': 'Failed to save event',
  'eo.toast.eventDeleted': 'Event deleted',
  'eo.toast.eventDeleteFailed': 'Failed to delete event',
  'eo.toast.activitySaved': 'Activity saved',
  'eo.toast.activitySaveFailed': 'Failed to save activity',
  'eo.toast.activityUpdated': 'Activity updated',
  'eo.toast.activityDeleted': 'Activity deleted',
  'eo.toast.activityDeleteFailed': 'Failed to delete activity',
  'eo.toast.activityReorderFailed': 'Failed to reorder',
  'eo.toast.participantAdded': 'Participant added',
  'eo.toast.participantAddFailed': 'Failed to add participant',
  'eo.toast.participantsImported': 'Imported {count} participants',
  'eo.toast.participantImportFailed': 'Import failed',
  'eo.toast.participantCheckedIn': 'Checked in',
  'eo.toast.participantCheckInFailed': 'Check-in failed',
  'eo.toast.partnerAdded': 'Partner added',
  'eo.toast.partnerSaved': 'Partner saved',
  'eo.toast.partnerLogAdded': 'Log added',
  'eo.toast.partnerLogAddFailed': 'Failed to add log',
  'eo.toast.partnerLogoOrderUpdated': 'Logo order updated',
  'eo.toast.partnerLogoOrderFailed': 'Failed to update order',
  'eo.toast.checklistTaskAdded': 'Task added',
  'eo.toast.checklistTemplateApplied': 'Added {count} tasks from template',
  'eo.toast.checklistTemplateFailed': 'Template import failed',
  'eo.toast.posterSaved': 'Poster saved',
  'eo.toast.posterSaveFailed': 'Failed to save poster',
  'dashboard.eo.open': 'Event Organizer workspace',
  'dashboard.eo.desc': 'Manage events, agendas, participants and partners.',
} as const;

export const eoZh: Record<keyof typeof eoEn, string> = {
  'eo.common.filter': '筛选',
  'eo.common.saving': '保存中…',
  'eo.workspace.title': '活动策划',
  'eo.workspace.subtitle': '请选择或创建活动',
  'eo.nav.overview': '总览',
  'eo.nav.events': '活动',
  'eo.nav.newEvent': '新建活动',
  'eo.nav.agenda': '议程',
  'eo.nav.participants': '参与者',
  'eo.nav.import': '导入',
  'eo.nav.poster': '海报',
  'eo.nav.partners': '合作伙伴',
  'eo.nav.partnerDetail': '伙伴详情',
  'eo.nav.checklist': '清单',
  'eo.nav.currentEvent': '当前活动',
  'eo.nav.switch': '切换活动',
  'eo.nav.modules': '模块',
  'eo.nav.account': '账户',
  'eo.nav.dashboard': '控制台',
  'eo.events.subtitle': '创建并管理您的活动',
  'eo.events.new': '新建活动',
  'eo.events.newHint': '从零开始',
  'eo.events.cap': '上限',
  'eo.event.status.live': '进行中',
  'eo.event.status.draft': '草稿',
  'eo.event.status.archived': '已归档',
  'eo.form.newSub': '填写活动基本信息',
  'eo.form.name': '活动名称',
  'eo.form.nameRequired': '请填写活动名称',
  'eo.form.venue': '场地',
  'eo.form.venueRequired': '请填写场地',
  'eo.form.description': '描述',
  'eo.form.start': '开始日期',
  'eo.form.startRequired': '请选择开始日期',
  'eo.form.end': '结束日期',
  'eo.form.endRequired': '请选择结束日期',
  'eo.form.endBeforeStart': '结束日期不能早于开始日期',
  'eo.form.totalDays': '时长',
  'eo.form.day': '天',
  'eo.form.days': '天',
  'eo.form.cap': '人数上限',
  'eo.form.cover': '封面图',
  'eo.form.coverHint': 'JPG 或 PNG，建议 16:9',
  'eo.form.chooseFile': '选择文件',
  'eo.form.saveContinue': '保存并继续',
  'eo.agenda.share': '分享',
  'eo.agenda.export': '导出',
  'eo.agenda.addActivity': '添加环节',
  'eo.agenda.conflictsDetected': '检测到议程冲突',
  'eo.agenda.conflictsHint': '同场地时间段重叠',
  'eo.agenda.list': '列表',
  'eo.agenda.timeline': '时间轴',
  'eo.agenda.exportStarted': '已开始导出',
  'eo.agenda.linkGenerated': '公开链接已创建',
  'eo.agenda.linkFailed': '无法更新公开链接',
  'eo.agenda.linkDisabled': '公开链接已关闭',
  'eo.agenda.editActivity': '编辑环节',
  'eo.agenda.ignoreSave': '仍要保存',
  'eo.agenda.resolveConflict': '解决冲突',
  'eo.agenda.activityTitle': '标题',
  'eo.agenda.date': '日期',
  'eo.agenda.start': '开始',
  'eo.agenda.end': '结束',
  'eo.agenda.venue': '场地/房间',
  'eo.agenda.type': '类型',
  'eo.agenda.conflictTitle': '与其他环节冲突',
  'eo.agenda.exportTitle': '导出议程',
  'eo.agenda.generating': '生成中…',
  'eo.agenda.startExport': '开始导出',
  'eo.agenda.format': '格式',
  'eo.agenda.shareTitle': '分享公开议程',
  'eo.agenda.previewPublic': '预览公开页',
  'eo.agenda.copied': '已复制',
  'eo.agenda.copyLink': '复制链接',
  'eo.agenda.shareHint': '持有链接者可只读查看议程。',
  'eo.agenda.generateLink': '生成链接',
  'eo.agenda.linkStatus': '公开链接',
  'eo.agenda.disableLink': '关闭链接',
  'eo.agenda.enableLink': '开启链接',
  'eo.public.expiredTitle': '链接已失效',
  'eo.public.expiredBody': '该公开议程链接已不可用。',
  'eo.public.eyebrow': '公开议程',
  'eo.public.footer': '由 N-Excelsior 提供',
  'eo.participants.total': '总计',
  'eo.participants.confirmed': '已确认',
  'eo.participants.attendance': '出席率',
  'eo.participants.import': '导入',
  'eo.participants.add': '添加参与者',
  'eo.participants.statTotal': '总数',
  'eo.participants.statConfirmed': '已确认',
  'eo.participants.statPending': '待确认',
  'eo.participants.statAttendance': '出席率',
  'eo.participants.search': '搜索姓名或邮箱',
  'eo.participants.allStatuses': '全部状态',
  'eo.participants.colName': '姓名',
  'eo.participants.colCompany': '公司',
  'eo.participants.colStatus': '状态',
  'eo.participants.colCheckin': '签到',
  'eo.participants.checkedIn': '已签到',
  'eo.participants.checkIn': '签到',
  'eo.participants.added': '已添加参与者',
  'eo.participants.name': '姓名',
  'eo.participants.email': '邮箱',
  'eo.participants.company': '公司',
  'eo.import.title': '导入参与者',
  'eo.import.subtitle': '上传含姓名、邮箱、公司列的 CSV',
  'eo.import.drop': '拖放 CSV 或浏览',
  'eo.import.total': '行数',
  'eo.import.valid': '有效',
  'eo.import.errors': '错误',
  'eo.import.back': '返回',
  'eo.import.confirm': '导入有效行',
  'eo.import.done': '导入完成',
  'eo.poster.title': '报名海报',
  'eo.poster.subtitle': '定制本活动的报名落地页海报',
  'eo.poster.previewLanding': '预览落地页',
  'eo.poster.saved': '海报已保存',
  'eo.poster.save': '保存海报',
  'eo.poster.templates': '模板',
  'eo.poster.customTitle': '标题',
  'eo.poster.deadline': '报名截止',
  'eo.poster.scanToRegister': '扫码报名',
  'eo.register.failed': '报名失败',
  'eo.register.successTitle': '报名成功',
  'eo.register.successBody': '确认邮件将很快发送。',
  'eo.register.full': '活动已满员。',
  'eo.register.closed': '报名已截止。',
  'eo.register.signInFirst': '登录后报名',
  'eo.register.submit': '提交报名',
  'eo.partners.subtitle': '赞助商与服务伙伴',
  'eo.partners.add': '添加伙伴',
  'eo.partners.allStatuses': '全部状态',
  'eo.partners.negotiating': '洽谈中',
  'eo.partners.confirmed': '已确认',
  'eo.partners.completed': '已完成',
  'eo.partners.terminated': '已终止',
  'eo.partners.added': '已添加伙伴',
  'eo.partners.company': '公司',
  'eo.partners.level': '级别',
  'eo.partners.tabInfo': '信息',
  'eo.partners.tabContract': '合同',
  'eo.partners.tabLog': '沟通记录',
  'eo.partners.contact': '联系人',
  'eo.partners.contractDue': '合同到期',
  'eo.partners.amount': '金额',
  'eo.partners.addLog': '添加记录',
  'eo.partners.logAdded': '已添加记录',
  'eo.checklist.subtitle': '活动前、中、后任务',
  'eo.checklist.useTemplate': '应用模板',
  'eo.checklist.pre': '活动前',
  'eo.checklist.during': '活动中',
  'eo.checklist.post': '活动后',
  'eo.checklist.newTask': '新任务标题…',
  'eo.toast.eventCreated': '活动已创建',
  'eo.toast.eventCreateFailed': '创建活动失败',
  'eo.toast.eventSaved': '活动已保存',
  'eo.toast.eventSaveFailed': '保存活动失败',
  'eo.toast.eventDeleted': '活动已删除',
  'eo.toast.eventDeleteFailed': '删除活动失败',
  'eo.toast.activitySaved': '议程项已保存',
  'eo.toast.activitySaveFailed': '保存议程项失败',
  'eo.toast.activityUpdated': '议程项已更新',
  'eo.toast.activityDeleted': '议程项已删除',
  'eo.toast.activityDeleteFailed': '删除议程项失败',
  'eo.toast.activityReorderFailed': '排序失败',
  'eo.toast.participantAdded': '参与者已添加',
  'eo.toast.participantAddFailed': '添加参与者失败',
  'eo.toast.participantsImported': '已导入 {count} 名参与者',
  'eo.toast.participantImportFailed': '导入失败',
  'eo.toast.participantCheckedIn': '已签到',
  'eo.toast.participantCheckInFailed': '签到失败',
  'eo.toast.partnerAdded': '合作伙伴已添加',
  'eo.toast.partnerSaved': '合作伙伴已保存',
  'eo.toast.partnerLogAdded': '记录已添加',
  'eo.toast.partnerLogAddFailed': '添加记录失败',
  'eo.toast.partnerLogoOrderUpdated': 'Logo 顺序已更新',
  'eo.toast.partnerLogoOrderFailed': '更新顺序失败',
  'eo.toast.checklistTaskAdded': '任务已添加',
  'eo.toast.checklistTemplateApplied': '已从模板添加 {count} 项任务',
  'eo.toast.checklistTemplateFailed': '模板导入失败',
  'eo.toast.posterSaved': '海报已保存',
  'eo.toast.posterSaveFailed': '保存海报失败',
  'dashboard.eo.open': '活动策划工作台',
  'dashboard.eo.desc': '管理活动、议程、参与者与合作伙伴。',
};

export const eoIt: Record<keyof typeof eoEn, string> = {
  'eo.common.filter': 'Filtra',
  'eo.common.saving': 'Salvataggio…',
  'eo.workspace.title': 'Event Organizer',
  'eo.workspace.subtitle': 'Seleziona o crea un evento',
  'eo.nav.overview': 'Panoramica',
  'eo.nav.events': 'Eventi',
  'eo.nav.newEvent': 'Nuovo evento',
  'eo.nav.agenda': 'Agenda',
  'eo.nav.participants': 'Partecipanti',
  'eo.nav.import': 'Importa',
  'eo.nav.poster': 'Poster',
  'eo.nav.partners': 'Partner',
  'eo.nav.partnerDetail': 'Dettaglio partner',
  'eo.nav.checklist': 'Checklist',
  'eo.nav.currentEvent': 'Evento corrente',
  'eo.nav.switch': 'Cambia evento',
  'eo.nav.modules': 'Moduli',
  'eo.nav.account': 'Account',
  'eo.nav.dashboard': 'Dashboard',
  'eo.events.subtitle': 'Crea e gestisci i tuoi eventi',
  'eo.events.new': 'Nuovo evento',
  'eo.events.newHint': 'Inizia da zero',
  'eo.events.cap': 'Posti',
  'eo.event.status.live': 'Live',
  'eo.event.status.draft': 'Bozza',
  'eo.event.status.archived': 'Archiviato',
  'eo.form.newSub': 'Dettagli base dell\'evento',
  'eo.form.name': 'Nome evento',
  'eo.form.nameRequired': 'Il nome è obbligatorio',
  'eo.form.venue': 'Sede',
  'eo.form.venueRequired': 'La sede è obbligatoria',
  'eo.form.description': 'Descrizione',
  'eo.form.start': 'Data inizio',
  'eo.form.startRequired': 'La data di inizio è obbligatoria',
  'eo.form.end': 'Data fine',
  'eo.form.endRequired': 'La data di fine è obbligatoria',
  'eo.form.endBeforeStart': 'La fine deve essere dopo l\'inizio',
  'eo.form.totalDays': 'Durata',
  'eo.form.day': 'giorno',
  'eo.form.days': 'giorni',
  'eo.form.cap': 'Partecipanti max',
  'eo.form.cover': 'Immagine di copertina',
  'eo.form.coverHint': 'JPG o PNG, consigliato 16:9',
  'eo.form.chooseFile': 'Scegli file',
  'eo.form.saveContinue': 'Salva e continua',
  'eo.agenda.share': 'Condividi',
  'eo.agenda.export': 'Esporta',
  'eo.agenda.addActivity': 'Aggiungi attività',
  'eo.agenda.conflictsDetected': 'Conflitti in agenda',
  'eo.agenda.conflictsHint': 'Attività sovrapposte nella stessa sede',
  'eo.agenda.list': 'Elenco',
  'eo.agenda.timeline': 'Timeline',
  'eo.agenda.exportStarted': 'Esportazione avviata',
  'eo.agenda.linkGenerated': 'Link pubblico creato',
  'eo.agenda.linkFailed': 'Impossibile aggiornare il link',
  'eo.agenda.linkDisabled': 'Link pubblico disattivato',
  'eo.agenda.editActivity': 'Modifica attività',
  'eo.agenda.ignoreSave': 'Salva comunque',
  'eo.agenda.resolveConflict': 'Risolvi conflitto',
  'eo.agenda.activityTitle': 'Titolo',
  'eo.agenda.date': 'Data',
  'eo.agenda.start': 'Inizio',
  'eo.agenda.end': 'Fine',
  'eo.agenda.venue': 'Sede / sala',
  'eo.agenda.type': 'Tipo',
  'eo.agenda.conflictTitle': 'Conflitto con un\'altra attività',
  'eo.agenda.exportTitle': 'Esporta agenda',
  'eo.agenda.generating': 'Generazione…',
  'eo.agenda.startExport': 'Avvia esportazione',
  'eo.agenda.format': 'Formato',
  'eo.agenda.shareTitle': 'Condividi agenda pubblica',
  'eo.agenda.previewPublic': 'Anteprima pagina pubblica',
  'eo.agenda.copied': 'Copiato',
  'eo.agenda.copyLink': 'Copia link',
  'eo.agenda.shareHint': 'Chi ha il link vede l\'agenda in sola lettura.',
  'eo.agenda.generateLink': 'Genera link',
  'eo.agenda.linkStatus': 'Link pubblico',
  'eo.agenda.disableLink': 'Disattiva link',
  'eo.agenda.enableLink': 'Attiva link',
  'eo.public.expiredTitle': 'Link scaduto',
  'eo.public.expiredBody': 'Questo link all\'agenda non è più valido.',
  'eo.public.eyebrow': 'Agenda pubblica',
  'eo.public.footer': 'Powered by N-Excelsior',
  'eo.participants.total': 'totale',
  'eo.participants.confirmed': 'confermati',
  'eo.participants.attendance': 'presenze',
  'eo.participants.import': 'Importa',
  'eo.participants.add': 'Aggiungi partecipante',
  'eo.participants.statTotal': 'Totale',
  'eo.participants.statConfirmed': 'Confermati',
  'eo.participants.statPending': 'In attesa',
  'eo.participants.statAttendance': 'Tasso presenze',
  'eo.participants.search': 'Cerca nome o email',
  'eo.participants.allStatuses': 'Tutti gli stati',
  'eo.participants.colName': 'Nome',
  'eo.participants.colCompany': 'Azienda',
  'eo.participants.colStatus': 'Stato',
  'eo.participants.colCheckin': 'Check-in',
  'eo.participants.checkedIn': 'Registrato',
  'eo.participants.checkIn': 'Check-in',
  'eo.participants.added': 'Partecipante aggiunto',
  'eo.participants.name': 'Nome',
  'eo.participants.email': 'Email',
  'eo.participants.company': 'Azienda',
  'eo.import.title': 'Importa partecipanti',
  'eo.import.subtitle': 'Carica un CSV con nome, email, azienda',
  'eo.import.drop': 'Trascina CSV o sfoglia',
  'eo.import.total': 'Righe',
  'eo.import.valid': 'Valide',
  'eo.import.errors': 'Errori',
  'eo.import.back': 'Indietro',
  'eo.import.confirm': 'Importa righe valide',
  'eo.import.done': 'Importazione completata',
  'eo.poster.title': 'Poster iscrizione',
  'eo.poster.subtitle': 'Personalizza il poster per la landing',
  'eo.poster.previewLanding': 'Anteprima landing',
  'eo.poster.saved': 'Poster salvato',
  'eo.poster.save': 'Salva poster',
  'eo.poster.templates': 'Modelli',
  'eo.poster.customTitle': 'Titolo',
  'eo.poster.deadline': 'Scadenza iscrizioni',
  'eo.poster.scanToRegister': 'Scansiona per iscriverti',
  'eo.register.failed': 'Iscrizione non riuscita',
  'eo.register.successTitle': 'Iscrizione completata',
  'eo.register.successBody': 'Riceverai un\'email di conferma a breve.',
  'eo.register.full': 'Evento al completo.',
  'eo.register.closed': 'Iscrizioni chiuse.',
  'eo.register.signInFirst': 'Accedi per iscriverti',
  'eo.register.submit': 'Iscriviti',
  'eo.partners.subtitle': 'Sponsor e partner di servizio',
  'eo.partners.add': 'Aggiungi partner',
  'eo.partners.allStatuses': 'Tutti gli stati',
  'eo.partners.negotiating': 'In trattativa',
  'eo.partners.confirmed': 'Confermato',
  'eo.partners.completed': 'Completato',
  'eo.partners.terminated': 'Terminato',
  'eo.partners.added': 'Partner aggiunto',
  'eo.partners.company': 'Azienda',
  'eo.partners.level': 'Livello',
  'eo.partners.tabInfo': 'Info',
  'eo.partners.tabContract': 'Contratto',
  'eo.partners.tabLog': 'Comunicazioni',
  'eo.partners.contact': 'Contatto',
  'eo.partners.contractDue': 'Scadenza contratto',
  'eo.partners.amount': 'Importo',
  'eo.partners.addLog': 'Aggiungi nota',
  'eo.partners.logAdded': 'Nota aggiunta',
  'eo.checklist.subtitle': 'Attività pre, durante e post evento',
  'eo.checklist.useTemplate': 'Applica modello',
  'eo.checklist.pre': 'Pre-evento',
  'eo.checklist.during': 'Durante evento',
  'eo.checklist.post': 'Post-evento',
  'eo.checklist.newTask': 'Nuova attività…',
  'eo.toast.eventCreated': 'Evento creato',
  'eo.toast.eventCreateFailed': 'Impossibile creare l\'evento',
  'eo.toast.eventSaved': 'Evento salvato',
  'eo.toast.eventSaveFailed': 'Impossibile salvare l\'evento',
  'eo.toast.eventDeleted': 'Evento eliminato',
  'eo.toast.eventDeleteFailed': 'Impossibile eliminare l\'evento',
  'eo.toast.activitySaved': 'Attività salvata',
  'eo.toast.activitySaveFailed': 'Impossibile salvare l\'attività',
  'eo.toast.activityUpdated': 'Attività aggiornata',
  'eo.toast.activityDeleted': 'Attività eliminata',
  'eo.toast.activityDeleteFailed': 'Impossibile eliminare l\'attività',
  'eo.toast.activityReorderFailed': 'Impossibile riordinare',
  'eo.toast.participantAdded': 'Partecipante aggiunto',
  'eo.toast.participantAddFailed': 'Impossibile aggiungere il partecipante',
  'eo.toast.participantsImported': 'Importati {count} partecipanti',
  'eo.toast.participantImportFailed': 'Importazione non riuscita',
  'eo.toast.participantCheckedIn': 'Check-in effettuato',
  'eo.toast.participantCheckInFailed': 'Check-in non riuscito',
  'eo.toast.partnerAdded': 'Partner aggiunto',
  'eo.toast.partnerSaved': 'Partner salvato',
  'eo.toast.partnerLogAdded': 'Nota aggiunta',
  'eo.toast.partnerLogAddFailed': 'Impossibile aggiungere la nota',
  'eo.toast.partnerLogoOrderUpdated': 'Ordine logo aggiornato',
  'eo.toast.partnerLogoOrderFailed': 'Impossibile aggiornare l\'ordine',
  'eo.toast.checklistTaskAdded': 'Attività aggiunta',
  'eo.toast.checklistTemplateApplied': 'Aggiunte {count} attività dal modello',
  'eo.toast.checklistTemplateFailed': 'Importazione modello non riuscita',
  'eo.toast.posterSaved': 'Poster salvato',
  'eo.toast.posterSaveFailed': 'Impossibile salvare il poster',
  'dashboard.eo.open': 'Workspace Event Organizer',
  'dashboard.eo.desc': 'Gestisci eventi, agenda, partecipanti e partner.',
};
